import React from 'react';

import VisuallyHidden from '@reach/visually-hidden';
import '@reach/dialog/styles.css';

import InfoModal from '../components/InfoModal';

import iconClose from '../../assets/close.svg';

import { breakpoints, colors } from '../config';

import cards from '../data/cards';

import useStore from '../store';

const Modal = ({ onDismiss = () => {} }) => {
  const [{ selectedGroup, selectedCard }, setStore] = useStore();

  function getCards(cardId) {
    return cards?.find(card => card.id === cardId);
  }

  function getCardTypes(cardId, types) {
    return types?.find(card => card.id === cardId);
  }

  let group = getCards(selectedGroup);
  let card = getCardTypes(selectedCard, group?.types);

  const isPlatinum = card?.badge?.title === 'Platinum';

  let title = group?.title;
  let subtitle = card?.brand + ' ' + card?.badge?.title;
  let cardImage = card?.image;

  return (
    <>
      <div className="modal-inner">
        <div className="modal-header">
          {cardImage && (
            <img
              className="modal-header-image"
              src={cardImage}
              width={isPlatinum ? 48 : 74}
              alt=""
            />
          )}

          <div>
            {title && <strong>{title}</strong>}
            {subtitle && <div>{subtitle}</div>}
          </div>

          <button className="close-button" onClick={onDismiss}>
            <VisuallyHidden>Cerrar</VisuallyHidden>
            <span aria-hidden>
              <img src={iconClose} alt="x" />
            </span>
          </button>
        </div>

        {selectedGroup && selectedCard && (
          <div className="modal-group-content">
            <InfoModal group={selectedGroup} card={selectedCard} />
          </div>
        )}
      </div>

      <style jsx>{`
        :global(reach-portal) {
          font-family: Arial, sans-serif;
          font-size: 15px;
          line-height: 1.5;
        }

        :global(reach-portal :focus) {
          outline: 0 !important;
        }

        :global(reach-portal a) {
          color: ${colors.orange};
          text-decoration: none;
        }

        :global(reach-portal p) {
          margin-bottom: 10px;
        }

        :global([data-reach-dialog-overlay]) {
          align-items: center;
          display: flex;
          overflow: hidden;
          z-index: 9999;
        }

        :global([data-reach-dialog-content]) {
          background: transparent;
          margin: 0 auto;
          padding: 0 !important;
          border-radius: ${colors.borderRadius};
        }

        @media screen and (max-width: ${breakpoints.md}) {
          :global([data-reach-dialog-content]) {
            width: 90vw !important;
          }
        }

        .modal-inner {
          background-color: ${colors.white};
          border-radius: ${colors.borderRadius};
          max-height: 80vh;
          overflow: hidden;
        }

        .modal-header {
          align-items: center;
          background-color: ${colors.lightPink};
          display: flex;
          font-family: ${colors.baseFontDisplay};
          font-size: 16px;
          height: 99px;
          padding: 24px;
          position: relative;
        }

        .modal-header strong {
          font-size: 18px;
          font-weight: 900;
        }

        .close-button {
          background: transparent;
          border: 0;
          cursor: pointer;
          font-family: inherit;
          margin: 0;
          padding: 0;
          position: absolute;
          right: 16px;
          top: 16px;
        }

        .modal-header-image {
          margin-right: 16px;
        }

        .modal-group-content {
          font-family: ${colors.baseFontDisplay};
          font-size: 16px;
          height: calc(80vh - 99px);
          overflow: scroll;
          padding: 24px;
        }

        .modal-group-content h3 {
          margin-bottom: 20px;
        }
      `}</style>
    </>
  );
};

export default Modal;
